export const module = {
  info: {
    name: 'voip-vos-cdr-viewer',
    caption: 'VOS CDR',
    viewGroup: 'status-and-report'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'CDR Viewer',
    icon: 'el-icon-s-data',
    routeName: 'module->voip-vos-cdr-viewer->list->page',
    routeParams: { listPage: 1}
    /*children: [
      {
        caption: 'Create Entity',
        icon: 'el-icon-plus',
        routeName: 'module->voip-vos-cdr-report->create'
      },
      {
        caption: 'List Entities',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-vos-cdr-report->list->page',
        routeParams: { listPage: 1}
      }
    ]*/
  }
}

export default module
